import { User } from '@microsoft/microsoft-graph-types';
import { IUserAutocompleteOption } from '@nimbus-library/features/shared/components/material/input-user-autocomplete/i-user-auto-complete-option.model';
import {
  UserAutoCompleteCallOptionType,
  UserAutoCompleteCallOptionTypeIconsMap,
} from '@nimbus-library/features/shared/services/user-search/models/user-auto-complete-value-type';
import { IUserAutoCompleteCallOption } from '@nimbus-library/features/shared/components/material/input-user-autocomplete/i-user-auto-complete-value.model';
import { InitialsPipe } from '@nimbus-library/features/shared/pipes/initials.pipe';

export class UserSearchMapper {
  private readonly initialPipe = new InitialsPipe();
  public handle(user: User, tenantId: string): IUserAutocompleteOption {
    const userOption: IUserAutocompleteOption = {
      image: `/api/ms-graph-api-adapter/v1/Users/${encodeURI(user.id)}/photo?tenantId=${tenantId}`,
      id: user.id,
      initials: this.initialPipe.transform(user.displayName),
      name: user.displayName,
      hasCallOptions: user.businessPhones?.length > 0 || !!user.mobilePhone,

      callOptions: [],
    };
    if (user.userPrincipalName) {
      userOption.callOptions.push(
        this.mapCallOption(user.id, user.userPrincipalName, UserAutoCompleteCallOptionType.upn, user.displayName),
      );
    }
    if (user.mobilePhone) {
      userOption.callOptions.push(this.mapCallOption(user.id, user.mobilePhone, UserAutoCompleteCallOptionType.mobile, user.displayName));
    }
    if (user.businessPhones?.length > 0) {
      const mappedPhones: IUserAutoCompleteCallOption[] = user.businessPhones.map((phone) =>
        this.mapCallOption(user.id, phone, UserAutoCompleteCallOptionType.business, user.displayName),
      );

      userOption.callOptions.push(...mappedPhones);
    }
    return userOption;
  }

  private mapCallOption(
    userId: string,
    phone: string,

    type: UserAutoCompleteCallOptionType,
    displayName?: string,
  ): IUserAutoCompleteCallOption {
    return {
      type,
      text: phone,
      isDisabled: false,
      icon: UserAutoCompleteCallOptionTypeIconsMap[type],
      userId,
      displayName,
    };
  }
}
